/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import LegalbirdIoModal from "../Modal/LegalbirdIoModal";
import React from "react";
import { Box, Button, Checkbox, FormControlLabel, FormLabel, Radio, RadioGroup, Stack, TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { getCaseLink } from "../../services/Product/ProductService/productService";
import { Link } from "react-router-dom";
import { translate } from "../../services/Translations/translatorService";
import { ProductUnion } from "../../types/ProductUnion";
import dayjs from "dayjs";

type OrganizationsHintsModalProps = {
  show: boolean;
  onClose: () => void;
  product: ProductUnion;
};

export const OrganizationsHintsModal = ({ show, onClose, product }: OrganizationsHintsModalProps) => {
  const { opposingPartyLegalEntity } = product;
  const hasInsolvency = Boolean(opposingPartyLegalEntity.organization.insolvencyStatus);
  const insolvencyStateLabelId = `${product.productClassName}.opposingPartyLegalEntity.organization.insolvenyStateLabelModal`;
  const translationPath = "contractualPartnerLegalEntity.";

  const caseLink = getCaseLink(product);

  const hintEditLink = caseLink + "/alle-daten#prozessbeteiligte-gegenseite";

  return (
    <LegalbirdIoModal
      title={"Hinweise zum Unternehmen: " + product.opposingParty}
      open={show}
      handleClose={onClose}
      hideCancelButton
      actionsInfo={
        <Button component={Link} to={hintEditLink} onClick={onClose}>
          Hinweise bearbeiten
        </Button>
      }
    >
      <Stack sx={{ rowGap: "0.5rem" }}>
        <TextField
          value={opposingPartyLegalEntity.organization.strategicHints}
          placeholder={translate(translationPath + "strategicHints.placeholder", "")}
          disabled={true}
          multiline
        />
        <FormControlLabel
          control={<Checkbox checked={hasInsolvency} disabled={true} />}
          label={translate(translationPath + "hasInsolvency.label", "")}
        />
        {hasInsolvency && (
          <Stack direction={"row"} sx={{ flexWrap: "wrap", columnGap: "1rem" }}>
            <Box>
              <FormLabel id={insolvencyStateLabelId}>
                {translate(translationPath + "insolvencyStatus.label", "")}
              </FormLabel>
              <RadioGroup
                aria-labelledby={insolvencyStateLabelId}
                value={opposingPartyLegalEntity.organization.insolvencyStatus}
              >
                <Stack direction={"row"}>
                  <FormControlLabel
                    control={<Radio value={"temporarily"} disabled={true} />}
                    label={translate(translationPath + "insolvencyStatus.temporarily", "")}
                  />
                  <FormControlLabel
                    control={<Radio value={"open"} disabled={true} />}
                    label={translate(translationPath + "insolvencyStatus.open", "")}
                  />
                  <FormControlLabel
                    control={<Radio value={"rejected"} disabled={true} />}
                    label={translate(translationPath + "insolvencyStatus.rejected", "")}
                  />
                </Stack>
              </RadioGroup>
            </Box>
            <Box sx={{ flexGrow: 1 }}>
              <DatePicker
                sx={{ width: "100%" }}
                label={translate(translationPath + "insolvencyStartDate.label", "")}
                value={
                  opposingPartyLegalEntity.insolvencyStartDate
                    ? dayjs(opposingPartyLegalEntity.insolvencyStartDate)
                    : null
                }
                disabled={true}
              />
            </Box>
          </Stack>
        )}
      </Stack>
    </LegalbirdIoModal>
  );
};
